/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useCoachChatContext } from 'bundles/ai-coach-platform/components/patterns/chat/context/CoachChatContext';
import SearchBar from 'bundles/ai-coach-platform/components/patterns/chat/search/SearchBar';

import _t from 'i18n!nls/ai-coach-platform';

const styles = {
  search: css`
    padding: var(--cds-spacing-100) var(--cds-spacing-200);
    height: 54px;
  `,
};

type Props = {
  onClose: () => void;
};

const FindInChatSearch = ({ onClose }: Props): React.ReactElement => {
  const { setSearchTerm, exitSearchMode } = useCoachChatContext();

  const handleSearch = (term: string) => {
    setSearchTerm(term);
  };

  const handleClose = () => {
    exitSearchMode();
    onClose();
  };

  const handleClear = () => {
    setSearchTerm('');
  };

  return (
    <div className="coach-find-in-chat-search" css={styles.search}>
      <SearchBar
        onSubmit={handleSearch}
        onClose={handleClose}
        onClear={handleClear}
        placeholder={_t('Find in chat')}
        aria-label={_t('Find in chat')}
      />
    </div>
  );
};

export default FindInChatSearch;
